<script lang="ts" setup>
import { useStoreConfig } from '~/store/storeConfig'
import getLocalizedRoute from '~/utils/getLocalizedRoute'

import { Routes } from '~/enums/Routes'
import Language from '~/components/Language.vue'

const { t } = useLang()
const storeConfig = useStoreConfig()

const year = new Date().getFullYear()

const { isAmeerikaEestis } = useTheme()
</script>

<template>
  <div
    class="copyright flex flex-col lg:flex-row items-center justify-between pb-4 lg:gap-4 max-w-xlg m-auto w-full lg:px-4">
    <div v-if="isAmeerikaEestis">
      <Language />
    </div>
    <div v-else class="flex justify-evenly lg:justify-start flex-wrap gap-2 w-full">
      <NuxtLink target="_blank" :to="getLocalizedRoute(Routes.PrivacyPolicy)">
        {{ t('nav.privacy-policy') }}
      </NuxtLink>
      <NuxtLink :to="getLocalizedRoute(Routes.ShipmentTracking.Tracking)">
        {{ t('common.shipment-tracking') }}
      </NuxtLink>
    </div>
    <hr v-if="storeConfig.getIsMobile" class="my-4 w-full" />
    <div class="w-full text-center lg:text-end">{{ t('footer.all-rights-reserved', { year }) }}</div>
  </div>
</template>

<style lang="postcss" scoped>
.copyright {
  @apply text-neutral7;

  div {
    a {
      @apply text-neutral7 focus:text-brand-primary hover:text-brand-primary;
    }
  }

  > div {
    a {
      @apply lg:pr-[2.5rem];
    }
  }
}

.alt {
  .copyright {
    a {
      @apply focus:text-white hover:text-white dark:text-black;
    }
  }
}

.wl {
  .copyright {
    a,
    div {
      @apply text-text2 dark:text-dmText2;
    }

    a {
      @apply focus:text-text1 dark:text-dmText1 hover:text-text1 dark:text-dmText1 dark:text-dmText1;
    }
  }
}

.nl {
  .copyright {
    a,
    div {
      @apply text-text1 dark:text-dmText1 dark:text-dmText1;
    }

    a {
      @apply focus:text-text1 dark:text-dmText1 hover:text-text1 dark:text-dmText1 dark:text-dmText1;
    }
  }
}

.ae {
  .copyright {
    a,
    div {
      @apply text-text1;
    }

    a {
      @apply focus:text-text1 hover:text-text1;
    }
  }
}
</style>
